import React from 'react'
import styled from '@emotion/styled'
import { breakpoints } from '~/utils/styles'

import { getButtonBackground } from '~/utils/helpers'

const Circle = ({ handle }) => {
  return (
    <Badge
      style={{
        backgroundColor: getButtonBackground(handle),
      }}
      className={handle}
    >
      <div>
        <span>
          25<small>mg</small>
        </span>{' '}
        CBD
      </div>
    </Badge>
  )
}

export default Circle

const Badge = styled.div`
  position: absolute;
  top: 30px;
  right: 30px;
  width: 100px;
  height: 100px;
  z-index: 1;
  color: white;
  border-radius: 100%;
  display: flex;
  text-align: center;
  font-family: 'SohneBreit';
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
  background: #215041;
  color: white;

  &.lemon-ginger-snack-bar {
    color: #215041;
  }

  span {
    font-size: 24px;
    display: block;

    small {
      font-size: 50%;
    }
  }

  @media (max-width: ${breakpoints.s}px) {
    right: 15px;
    top: 15px;
    width: 80px;
    height: 80px;

    span {
      font-size: 20px;
    }
  }
`
